<template>
    <div class="ReAddBalanceHistory">
        <collapse activeIndexType="BalanceHistory">
            <collapse-item @activate="onShow">	
                <template v-slot:title>
                    <div class="col-title">
                        <h3 class="mb-0">История пополнений счёта</h3>
                    </div>
                </template>
                <!-- 
                <div>
                    <table>
                        <thead><tr><th>Дата</th><th>Сумма</th><th>Статус</th><th></th></tr></thead>
                        <tbody>
                            <tr v-for="row in data" :key="row.id">
                                <td>{{row.date}}</td>
                                <td>{{row.amount}}</td>
                                <td>{{showResult(row.result)}}</td>
                                <td><a v-on:click="checkPay(row.orderId)" v-if="row.result==0">Проверить статус</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                -->
                <card>
                    <el-table 
                    ref="multipleTable"
                    :data="data" 
                    style="width: 100%"
                    :row-key="row => row.id"
                    >	

                        <el-table-column
                        label="Дата"
                        min-width="100"
                        prop="date">
                            <template v-slot="scope">
                                <span>{{ $GVO.convertDateTimeFromMysql(scope.row.date) }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column
                            width="140"
                            label="Сумма"
                            prop="result"
                            >
                            <template v-slot="scope">
                                <div>{{$GVO.number_format(scope.row.amount,0,'.',' ')}} ₽</div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            width="140"
                            label="Статус"
                            prop="amount"
                            >
                            <template v-slot="scope">
                                <div>{{showResult(scope.row.result)}}</div>
                            </template>
                        </el-table-column>

                        <el-table-column
                        label="Действия"
                        min-width="100"
                        >
                            <template v-slot="scope">
                                <button v-on:click="checkPay(scope.row.orderId)" v-if="scope.row.result==0" class="btn btn-simple btn-success"> Проверить статус </button>
                            </template>
                        </el-table-column>
                    </el-table>
                </card>
            </collapse-item>
		</collapse>
        <!--
        <a v-if="!show" v-on:click="onShow()" style="opacity:0.1">Тут будет история пополнений счёта</a>
        -->
    </div>
</template>

<script>
import { Collapse, CollapseItem } from 'src/components';
import { Table, TableColumn } from 'element-ui';
export default{
    name: 'ReAddBalanceHistory',
    components: {
        Collapse, 
		CollapseItem,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    data(){
        return {
            show:false,
            data:[],
        }
    },
    props:{
        onSuccess: {
            type:Function,
            default(){},
        }
    },
    methods:{
        async onShow(){
            this.show=true;
            let result = await this.$GVO.Api.billing.get_my_bills({})
            if(result.success){
                this.data = result.data;
            }
        },
        showResult(r){
            if(r==2) return 'Успешно';
            return 'В обработке';
        },
        async checkPay(orderId){
            let result = await this.$GVO.Api.billing.check_pay({flt:{orderId}})
            if(result.success){
                await this.onShow();
                this.$emit("refrashrentcharge", result.success);
            }
        }
    }
}
</script>

<style scoped>
.card-collapse > .card > .card-header {border-bottom: 2px solid #01B0E0;}
.card-collapse .card:not(.card-cinc) .card-header h3 {color: #01B0E0;}
.ReAddBalanceHistory >>> .card-collapse .card .card-header a[data-toggle="collapse"] i {bottom: 7px;}
.card-collapse .card:not(.card-cinc) .card-header {padding: 0.75rem 0.75rem 0 0.75rem;}
.col-title{
	display: inline-flex;
	width: 100%;
	/* width: calc(100% - 20px); */
	align-items: baseline;
}
.col-title > *{
	display: inline-block;
	margin-bottom: 0px;
}

.ReAddBalanceHistory >>> .el-table tr:hover {background: rgb(1, 176, 224, 0.33);}
.ReAddBalanceHistory >>>  .el-table .cell {word-break: break-word; }
.ReAddBalanceHistory >>> .white-content .card:not(.card-white) .el-table .cell {color: #222a42!important;}

</style>